import React from 'react';

import { useSessionMonitor } from '@/hooks/useSessionMonitor';

/**
 * Enterprise-grade session monitoring component
 * Provides silent background monitoring with user-friendly notifications
 *
 * Inspired by:
 * - Netflix: Silent refresh → Gentle notification
 * - Stripe: Background monitoring → In-app banner
 * - Figma: Proactive alerts → Auto-save protection
 * - Linear: Seamless background refresh → Toast notification
 */
interface SessionMonitorProviderProps {
  children: React.ReactNode;
}

export const SessionMonitorProvider: React.FC<SessionMonitorProviderProps> = ({ children }) => {
  useSessionMonitor();

  return <>{children}</>;
};
